import { motion } from "motion/react";
import { useAppStore } from "../stores/useAppStore";

export default function HomeQR({className = ''}) {
    const { setHomeQRIsOpen } = useAppStore();

    const handleClick = () => {
        setHomeQRIsOpen(false);
    };

    return (
        <motion.div 
            className={`fixed inset-0 w-full h-full backdrop-blur-md bg-black/30 z-50 flex items-center justify-center cursor-pointer ${className}`}
            onClick={handleClick}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            <motion.div 
                className="bg-white rounded-[5rem] p-8 w-[40%] aspect-square flex items-center justify-center cursor-pointer"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <img
                    src={`${process.env.PUBLIC_URL}/qr/app_qr.png`}
                    alt="QR Code"
                    className="w-full h-full object-contain"
                />
            </motion.div>
        </motion.div>
    );
};
